import { toast } from 'react-toastify';
import toastr from 'toastr';
// import jQuery from 'jquery';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import * as types from '../constants/actionTypes';
// import * as auth from '../tools/auth0.cred';
import * as api from '../tools/apiConfig';

export function getMarketSpecializationList(props) {
	
	return function (dispatch, getState) {
		axios.get(api.GET_MARKETING_SPECIALIZATION, {
			headers: {
				'Content-Type': 'application/json',
				// 'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_MARKETING_SPECIALIZATION, specializationList: response.data.data });
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
				else {
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {
				
			});
	}
}

export function getMarketSpecialistList(data, props) {


	return function (dispatch, getState) {
		dispatch({ type: types.GET_CONVERTED_CURRENCY, convertedCurrency: null })

		axios.post(api.GET_MARKETING_SPECIALISTS_LIST, data, {
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {
					if (data) {
						response.data.data.specialists = data.user;
						response.data.data.per_page = data.per_page;
						return dispatch({ type: types.GET_MARKETING_SPECIALISTS_LIST, specialistList: response.data.data })

					}

				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toast.error(response.data.message);
				}

			})
			.catch(function (error) {
				

			});
	}
}

export function getMarketOtherConsultationAddress(data, props) {

	return function (dispatch, getState) {
		axios.post(api.GET_MARKET_OTHER_CONSULTATION_ADDRESS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_MARKET_OTHER_CONSULTATION_ADDRESS, otherConsultationAddress: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

export function getCmsPageContent(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_CMS_PAGE_CONTENT, data, {
			headers: {
				'Content-Type': 'application/json',
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_CMS_PAGE_CONTENT, pageContent: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

export function saveContactUsForm(data, props) {
	return function (dispatch, getState) {
		axios.post(api.SAVE_CONTACT_US_FORM, data, {
			headers: {
				'Content-Type': 'application/json',
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
					// return dispatch({ type: types.GET_CMS_PAGE_CONTENT, pageContent: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}
